import { render, staticRenderFns } from "./SpacesManage.vue?vue&type=template&id=0347338c&"
import script from "./SpacesManage.vue?vue&type=script&lang=js&"
export * from "./SpacesManage.vue?vue&type=script&lang=js&"
import style0 from "./SpacesManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports